import { apiRequest } from '../core';

export function getStatisticByUserId(userId) {
  const url = new URL(`${process.env.REACT_APP_BACKEND_HOST}/api/statistic/${userId}`);
  return apiRequest(url);
}

export function likePractice(practiceCaseId, ...args) {
  const url = new URL(`${process.env.REACT_APP_BACKEND_HOST}/api/statistic/like/${practiceCaseId}`);
  return apiRequest(url, {
    method: 'POST',
    credentials: 'same-origin',
    body: null,
  }, args ? args[0] : true);
}

export function setTrainingMaterialIsDownload(materialId) {
    const url = new URL(`${process.env.REACT_APP_BACKEND_HOST}/api/statistic/downloadmaterial/${materialId}`);
    return apiRequest(url, {
        method: 'POST',
        credentials: 'same-origin',
        body: null
    });
}
